import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { Attivazione, Status } from './../../../models/attivazione';
import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { VulnerabilityType } from '../../../models/product';

@Component({
  selector: 'alg-attivazioni-step3',
  templateUrl: './alg-attivazioni-step3.component.html',
  styleUrls: ['./alg-attivazioni-step3.component.scss']
})
export class AlgAttivazioniStep3Component implements OnInit {

  public attivazione: Attivazione = {} as Attivazione;
  public downloadPDFlink: string = '';
  public loadingPdf: boolean = false;
  public downloadedPDF: boolean = false;
  public hasBaseDropZoneOver: boolean = false;
  public secondIstanza: boolean = false;
  public istanzaUploader1: FileUploader;
  public showProgress1: boolean = false;
  public istanzaUploader2: FileUploader;
  public showProgress2: boolean = false;
  public istanzaUploader3: FileUploader;
  public showProgress3: boolean = false;
  public istanzaUploader4: FileUploader;
  public showProgress4: boolean = false;
  //identity
  public idCardUploader1: FileUploader;
  public showProgress5: boolean = false;
  public idCardSecondIstanza: boolean = false;
  public idCardUploader2: FileUploader;
  public showProgress6: boolean = false;
  public isProductGasVulnerable: boolean;
  public vulnerabilityType: VulnerabilityType;
  public vulnerabilityCheckboxes = false;
  public vulnerabilityAcceptance = {
    socialBonus: false,
    disability: false,
    housingEmergency: false,
  }

  public folderUrl: string = '';

  constructor(
    private api: AlgAttivazioniService,
  ) { }

  ngOnInit() {
    this.api.attivazione$.pipe(
      tap((attivazione) => {
        //
      })
    ).subscribe((attivazione) => {
      this.setUploaders(attivazione);
      this.attivazione = attivazione;
      this.isProductGasVulnerable = this.attivazione.NewProductName === 'ALG Vulnerabile Gas Domestico' && this.attivazione.vulnerabilityType !== undefined ? true : false;
      this.vulnerabilityType = this.attivazione.vulnerabilityType;
      // Check vulnerabilityType and set vulnerabilityAcceptance properties
      this.api.vulnerabilityTypeUserSelected$.next(this.attivazione.vulnerabilityType);
      if (this.attivazione.vulnerabilityType === VulnerabilityType.socialBonus) {
        this.vulnerabilityAcceptance.socialBonus = true;
      } else if (this.attivazione.vulnerabilityType === VulnerabilityType.disability) {
        this.vulnerabilityAcceptance.disability = true;
      } else if (this.attivazione.vulnerabilityType === VulnerabilityType.housingEmergency) {
        this.vulnerabilityAcceptance.housingEmergency = true;
      }

      if (Object.keys(attivazione.istanzaFilled1).length !== 0 && attivazione.istanzaFilled1.constructor === Object) {
        this.downloadedPDF = true;
        this.showProgress1 = true;
      };

      if (Object.keys(attivazione.istanzaFilled2).length !== 0 && attivazione.istanzaFilled2.constructor === Object) {
        this.downloadedPDF = true;
        this.secondIstanza = true;
        this.showProgress2 = true;
      };

      if (Object.keys(attivazione.istanzaFilled3).length !== 0 && attivazione.istanzaFilled3.constructor === Object) {
        this.downloadedPDF = true;
        this.secondIstanza = true;
        this.showProgress3 = true;
      };

      if (Object.keys(attivazione.istanzaFilled4).length !== 0 && attivazione.istanzaFilled4.constructor === Object) {
        this.downloadedPDF = true;
        this.secondIstanza = true;
        this.showProgress4 = true;
      };

      if (Object.keys(attivazione.idCard1).length !== 0 && attivazione.idCard1.constructor === Object) {
        this.showProgress5 = true;
      };
      if (Object.keys(attivazione.idCard2).length !== 0 && attivazione.idCard2.constructor === Object) {
        this.idCardSecondIstanza = true;
        this.showProgress6 = true;
      };
      // if(this.attivazione.id) this.downloadPDFlink = environment.attivazioneUrl+this.attivazione.id+'.pdf';
    });

  }

  setUploaders(attivazione: Attivazione) {
    if (this.attivazione.webStatus == 'complete') return;
    //upload istanza 1
    this.istanzaUploader1 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'istanzaFilled1',
      autoUpload: true
    });

    this.istanzaUploader1.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_ist_1.${ext}`;
    }

    this.istanzaUploader1.onAfterAddingFile = (file) => {
      this.showProgress1 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader1.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.istanzaFilled1 = res.istanzaFilled1;
        this.api.istanzaGifSubject.next(3);
      };
      this.checkFileSize(this.attivazione.istanzaFilled1, 'istanzaFilled1');
    };


    //upload istanza 2
    this.istanzaUploader2 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'istanzaFilled2',
      autoUpload: true
    });

    this.istanzaUploader2.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_ist_2.${ext}`;
    }

    this.istanzaUploader2.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader2.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.istanzaFilled2 = res.istanzaFilled2;
      };
      this.checkFileSize(this.attivazione.istanzaFilled2, 'istanzaFilled2');
    };

    //upload istanza 3
    this.istanzaUploader3 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'istanzaFilled3',
      autoUpload: true
    });

    this.istanzaUploader3.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_ist_3.${ext}`;
    }

    this.istanzaUploader3.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader3.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.istanzaFilled3 = res.istanzaFilled3;
      };
      this.checkFileSize(this.attivazione.istanzaFilled3, 'istanzaFilled3');
    };

    //upload istanza 4
    this.istanzaUploader4 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'istanzaFilled4',
      autoUpload: true
    });

    this.istanzaUploader4.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_ist_4.${ext}`;
    }

    this.istanzaUploader4.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader4.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.istanzaFilled4 = res.istanzaFilled4;
      };
      this.checkFileSize(this.attivazione.istanzaFilled4, 'istanzaFilled4');
    };

    // upload idCard1
    this.idCardUploader1 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'idCard1',
      autoUpload: true
    });

    this.idCardUploader1.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_CI_1.${ext}`;
    }

    this.idCardUploader1.onAfterAddingFile = (file) => {
      this.showProgress5 = true;
      file.withCredentials = false;
    };

    this.idCardUploader1.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.idCard1 = res.idCard1;
      };
      this.checkFileSize(this.attivazione.idCard1, 'idCard1');

    };

    // upload idCard2
    this.idCardUploader2 = new FileUploader({
      url: `${environment.api.basePath}/upload-istanza/${attivazione.id}`,
      itemAlias: 'idCard2',
      autoUpload: true
    });

    this.idCardUploader2.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${attivazione.opportunityId}_CI_2.${ext}`;
    }

    this.idCardUploader2.onAfterAddingFile = (file) => {
      this.showProgress6 = true;
      file.withCredentials = false;
    };

    this.idCardUploader2.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.attivazione.idCard2 = res.idCard2;
      };
      this.checkFileSize(this.attivazione.idCard2, 'idCard2');
    };

    //visible upload buttons

  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public deleteFile(filelabel, filename) {
    const data = {
      id: this.attivazione.id,
      file: filelabel,
      fileName: filename
    };
    this.api.deleteIstanza(data).toPromise().then((resp) => {
      if (resp.result.body === 'OK') {
        if (filelabel == 'istanzaFilled1') {
          this.showProgress1 = false;
        } else if (filelabel == 'istanzaFilled2') {
          this.showProgress2 = false;
          this.secondIstanza = false;
        } else if (filelabel == 'idCard1') {
          this.showProgress5 = false;
        } else if (filelabel == 'idCard2') {
          this.showProgress6 = false;
          this.idCardSecondIstanza = false;
        };
        this.attivazione[filelabel] = {};
      };
    });
  };

  public checkFileSize(obj: any, fileId: string) {
    if (obj.size > 25000000) {
      this.deleteFile(`${fileId}`, obj.filename);
      alert('File troppo grande. Max: 25MB');
    };
  };

  public isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  };

  public alertMaxNumberFiles(fileType: string) {
    if (fileType === 'module') {
      alert('Puoi inserire massimo 4 moduli');
    } else if (fileType === 'document') {
      alert('Puoi inserire solo 1 documento fronte retro');
    }
  };

  downloadPdf(data) {
    var newBlob = new Blob([data], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(newBlob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  public downloadIstanza() {
    this.loadingPdf = true;
    this.api.getDocumentsAttivazioni(this.attivazione.opportunityId)
    .toPromise().then((data)=>{
    this.downloadedPDF = true;
    this.loadingPdf = false;    
      return this.downloadPdf(data);
    }).catch((err)=>{
      this.downloadedPDF = false;
      this.loadingPdf = false;
      console.log(err);
    })
  }

  public showVulnerabilityCheckboxes() {
    this.vulnerabilityCheckboxes = !this.vulnerabilityCheckboxes
  }

  public changeCheckbox(checkboxName: string) {
    switch (checkboxName) {
      case VulnerabilityType.socialBonus:
        this.vulnerabilityAcceptance.socialBonus = !this.vulnerabilityAcceptance.socialBonus;
        this.vulnerabilityAcceptance.disability = false;
        this.vulnerabilityAcceptance.housingEmergency = false;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.socialBonus);
        break;
      case VulnerabilityType.disability:
        this.vulnerabilityAcceptance.socialBonus = false;
        this.vulnerabilityAcceptance.disability = !this.vulnerabilityAcceptance.disability;
        this.vulnerabilityAcceptance.housingEmergency = false;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.disability);
        break;
      case VulnerabilityType.housingEmergency:
        this.vulnerabilityAcceptance.socialBonus = false;
        this.vulnerabilityAcceptance.disability = false;
        this.vulnerabilityAcceptance.housingEmergency = !this.vulnerabilityAcceptance.
        housingEmergency;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.housingEmergency);
        break;
    }
  }

  public nextStep() {
    if ((!this.isEmptyObject(this.attivazione.istanzaFilled1) || !this.isEmptyObject(this.attivazione.istanzaFilled2)) || !this.isEmptyObject(this.attivazione.istanzaFilled3) || !this.isEmptyObject(this.attivazione.istanzaFilled4) && (!this.isEmptyObject(this.attivazione.idCard1) || !this.isEmptyObject(this.attivazione.idCard2))) {
      this.api.nextStep(this.attivazione, Status.step1);

    };
  };

};



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-step3/alg-attivazioni-step3.component.ts